
// src/web/index.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, hashHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { AppContainer } from 'react-hot-loader'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { mediaQueryTracker} from 'redux-mediaquery'

import './styles/index.scss'
import i18n from '../i18n'
import configureStore from '../store/configureStore'
import routes from './routes'
import config from '../config'
import 'smart-app-banner/index.css'
import SmartBanner from 'smart-app-banner'
import outdatedBrowserRework from 'outdated-browser-rework'
import "./outdated-browser-rework-style.scss"
import * as Sentry from '@sentry/react'

const store = configureStore(hashHistory)
const history = syncHistoryWithStore(hashHistory, store)

/* 
 * -----------Sentryの初期化-----------
 * dsn: sentryの設定用データ
 * environment: production/staging/(developmment),
 * enableAutoSessionTracking: リリースの状態監視 使用状況/クラッシュの割合など
 * sessionTrackingIntervalMillis: セッションの開始・終了のトラッキング　デフォルトは30秒
 * debug: デバッグモード(Sentry log 出力)
 */
process.env.RAILS_ENV == 'production' && Sentry.init({
  dsn: config.sentry.dsn,
  release: 'gamba-web@' + process.env.BUILD_NO,
  enableAutoSessionTracking: true,
  sessionTrackingIntervalMillis: 30000,
  debug: false
});

outdatedBrowserRework({
  messages: {
		ja: {
  		outOfDate: "最新のWebブラウザをインストールしてください。",
  		unsupported: "最新のWebブラウザをインストールしてください。",
			update: {
        web: "お客様の環境では一部機能が動作しない可能性があります。",
				googlePlay: "Google PlayよりChromeブラウザをインストールしてください。",
				appStore: "設定アプリよりiOSのバージョンを最新版にアップデートしてください。"
			},
			url: "http://outdatedbrowser.com/ja",
			callToAction: "最新のWebブラウザをインストールする",
			close: "閉じる"
		}
	}
})

const unlisten = mediaQueryTracker({
  isPhone: "screen and (max-width: 767px)",
  innerWidth: true,
  innerHeight: true,
}, store.dispatch)

store.dispatch(mediaQueryTracker({
  isPhone: "screen and (max-width: 767px)",
  innerWidth: true,
  innerHeight: true,
}))

document.ondragover = (e)=> { e.preventDefault(); return false; }
document.ondrop     = (e)=> { e.preventDefault(); return false; }

new SmartBanner({
  title: i18n.t('label:gamba'),
  author: i18n.t('label:株式会社gamba'),
  button: i18n.t('label:ダウンロード'),
  store: {
      ios: 'App Store',
      android: 'Google Play',
  },
  price: {
    ios: i18n.t('label:無料'),
    android: i18n.t('label:無料'),
  }
});

const render = ()=> {
  const lang_param = document.location.search && document.location.search.match(/lang=([a-z][a-z])/)
  const language = lang_param ? lang_param[1] : navigator.language.replace(/-[a-zA-Z]+$/, '')
  i18n.changeLanguage(language, ()=> {
    return ReactDOM.render(
      <AppContainer>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <Router history={history} routes={routes}/>
          </I18nextProvider>
        </Provider>
      </AppContainer>,
      document.querySelector("#app")
    )
  })
}

render()



// WEBPACK FOOTER //
// ./src/web/index.js